// src/config.js

// Local dev: uses http://localhost:4000
// Live: set REACT_APP_API_BASE in .env (example: https://rmsworld.com)

export const API_BASE =
  process.env.REACT_APP_API_BASE || "";